import React from "react";
import {
  VendorDocumentationPageConfig,
  VendorDocumentationPageContent,
} from "../../../data-map/vendor-documentation/VendorDocumentationPage";
import { Routes } from "../../../../root/routes";
import { HRDataMapTabs } from "./HRDataMapTabs";

const HR_VENDOR_DOCUMENTATION_CONFIG: VendorDocumentationPageConfig = {
  collectionContext: ["EMPLOYEE"],
  includeEmptyContext: false,
  breadcrumbTitle: "Vendor Documents",
  breadcrumbSource: "HR Center",
  breadcrumbSourceRoute: Routes.hrCenter.root,
  doneRoute: Routes.hrCenter.hrDataMap.retentionSchedule,
  doneStepName: "the Retention Schedule",
  headerElement: <HRDataMapTabs selectedTabKey="hr-vendor-documentation" />,
};

export function HRVendorDocumentationPage() {
  return <VendorDocumentationPageContent config={HR_VENDOR_DOCUMENTATION_CONFIG} />;
}
